import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box, Button, Card, Grid, styled, Typography } from '@mui/material';
import axios from 'axios';
import { compareDesc, parseISO } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import TeacherApprove from '../components/Actions/TeacherApprove';
import TeacherCompleted from '../components/Actions/TeacherCompleted';
import BookingHeader from '../components/BookingInfo/BookingHeader';
import BookingRating from '../components/BookingInfo/BookingRating';
import BookingSubDetails from '../components/BookingInfo/BookingSubDetails';
import NoBookingFound from '../components/BookingInfo/NoBookingFound';
import SchoolInfoProvided from '../components/BookingInfo/SchoolInfoProvided';
import TeacherFeedback from '../components/BookingInfo/TeacherFeedback';
import Loading from '../components/Loading';
import Title from '../components/Navbar/Title';
import SimpleSnackbar from '../components/SnackBar/SimpleSnackbar';
import sendNotification from '../utils/sendNotification';
import {
    addAvailability,
    fetchMyAvailability,
    updateStatus as updateAvailStatus,
} from '../redux/AvailabilitySlice';
import {
    fetchQuickBooking,
    fetchTeacherBooking,
    quickBookingConfirmed,
    updateStatus as updateBookingStatus,
} from '../redux/BookingSlice';

import SimpleMap from '../components/Profile/SimpleMap';
import SignSchoolDocs from '../components/BasicComponents/SignSchoolDocs';

const RootGrid = styled(Grid)(({ theme }) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
}));

const SelectEmptyGrid = styled(Grid)(({ theme }) => ({
    margin: theme.spacing(3),
}));

const TeacherCard = styled('div')(() => ({
    margin: '20px',
}));

const BookingButton = styled(Button)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '150px',
    borderRadius: '30px',
}));

export const ViewTeacherBooking = props => {
    // const classes = useStyles();
    let match = useRouteMatch('/:basePath/teacher-booking/:bookingId');
    //const id = 0;

    const { getAccessTokenSilently } = useAuth0();

    const { booking, quickBooking } = useSelector(state => state.booking);
    const { profile } = useSelector(state => state.profile);
    const { availability } = useSelector(state => state.availability);
    const availabilityStatus = useSelector(state => state.availability.status);
    const bookingStatus = useSelector(state => state.booking.status);
    const quickBookingStatus = useSelector(state => state.booking.quickStatus);

    const dispatch = useDispatch();

    let history = useHistory();

    const [state, setState] = useState({
        teachersInSchool: { value: '', error: '', errorCode: '' },
        teacherList: [],
        booking: {},
        bookingStatus: 0,
        bookingResponse: '',
    });
    const [snackState, setSnackState] = useState({
        snackBarMessage: '',
        openSnack: false,
        snackSeverity: 'success',
    });

    const [signDocsOpen, setSignDocsOpen] = useState(false);
    const [schoolDocsInfo, setSchoolDocsInfo] = useState({});
    const [cached, setCached] = useState({});

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (bookingStatus === 'succeeded') {
            var selected = booking.Data.filter(book => {
                return book.uniqueId === match.params.bookingId;
            });
            if (selected.length === 0) {
                if (quickBookingStatus === 'succeeded') {
                    selected = quickBooking.Data.filter(book => {
                        return book.uniqueId === match.params.bookingId;
                    });
                } else {
                    async function dispatchQBookingFromStore() {
                        const token = await getAccessTokenSilently({
                            scope: process.env.REACT_APP_scope,
                        });
                        const quickBookings = await dispatch(
                            fetchQuickBooking({ token: token })
                        );
                        console.log('quickBookings', quickBookings);
                        selected =
                            quickBookings.payload.data.Message.Data.filter(
                                book => {
                                    return (
                                        book.uniqueId === match.params.bookingId
                                    );
                                }
                            );
                    }
                    dispatchQBookingFromStore();
                }
            }
            console.log('Use effect called for booking found', selected);
            if (selected.length === 1) {
                console.log('Booking Status should be', selected[0].status);
                setState({
                    ...state,
                    booking: selected[0],
                    bookingStatus: 2,
                    previousHistory: match.params.basePath,
                });
            } else {
                console.log('Booking not found', selected);
            }
        } else if (bookingStatus === 'failed') {
            setState({
                ...state,
                bookingStatus: 3,
                previousHistory: match.params.basePath,
            });
        } else if (bookingStatus === 'idle') {
            async function dispatchBookingFromStore() {
                const token = await getAccessTokenSilently({
                    scope: process.env.REACT_APP_scope,
                });
                dispatch(fetchTeacherBooking({ token: token }));
            }
            // console.log('theme ' + JSON.stringify(classes));
            dispatchBookingFromStore();
            setState({
                ...state,
                bookingStatus: 1,
                previousHistory: match.params.basePath,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [booking, bookingStatus, quickBookingStatus, quickBooking]);

    function goBack() {
        history.goBack();
    }

    function goHome() {
        history.push('/home');
    }

    const getAvailability = (avail, token) => {
        return new Promise(async (resolve, reject) => {
            if (avail.length > 0) {
                console.log('availExists - Setting availLocal', avail);
                resolve({
                    'pk1': avail[0].pk1,
                    'sk1': avail[0].sk1,
                });
            } else {
                //create availability
                console.log('profile', profile);
                let dynamoData = {
                    token: token,
                    request: {
                        grade: profile.Data.Items[0].grades,
                        address: profile.Data.Items[0].address,
                        addDates: [
                            {
                                startDate: state.booking.startDate,
                                endDate: state.booking.endDate,
                            },
                        ],
                        lat: profile.Data.Items[0].lat,
                        long: profile.Data.Items[0].long,
                        type: profile.Data.Items[0].type,
                        teacherName: profile.Data.Items[0].sk1,
                        teacherProfile: profile.Data.Items[0].profileImage,
                        skills: profile.Data.Items[0].skills,
                        otherSkills: profile.Data.Items[0].otherSkills,
                        bio: profile.Data.Items[0].bio,
                        repeat: 0,
                        status: 'Available',
                    },
                };
                console.log(
                    'Data to Send ' + JSON.stringify(dynamoData.request)
                );
                const outcome = await dispatch(addAvailability(dynamoData));
                console.log('outcome', outcome);
                resolve({
                    'pk1': outcome.payload.data.availability[0].Message.Data
                        .pk1,
                    'sk1': outcome.payload.data.availability[0].Message.Data
                        .sk1,
                });
            }
        });
    };

    const addQuickBookAndAvail = async (
        bookingItem,
        avail,
        changeStatus,
        token,
        date,
        approve,
        route,
        originalStatus
    ) => {
        //data.pk1 = 'r1r34-20210824' // state.booking.startDate = '2022-10-29T08:00:00'

        const availExists = avail.filter(
            data =>
                data.pk1.substring(6) ===
                `${bookingItem.startDate.substr(
                    0,
                    4
                )}${bookingItem.startDate.substr(
                    5,
                    2
                )}${bookingItem.startDate.substr(8, 2)}`
        );
        const availabilityLocal = await getAvailability(availExists, token);
        const data = {
            'request': {
                'approve': approve.toString(),
                'date': date,
                'availPk1': availabilityLocal.pk1,
                'availSk1': availabilityLocal.sk1,
                'bookPk1': bookingItem.pk1,
                'bookSk1': bookingItem.sk1,
            },
        };
        const response = await axios
            .put(route, data.request, {
                baseURL: process.env.REACT_APP_API_GATEWAY,
                url: route,
                timeout: 30000,
                headers: {
                    authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            })
            .then(response => {
                console.log('response', response);

                try {
                    const availStatus = {
                        status: response.data.Message.Data.availStatus,
                        id: response.data.Message.Data.availUniqueId,
                    };
                    dispatch(updateAvailStatus(availStatus));
                } catch {
                    console.log('Availability not in memory');
                }

                if (response.data.Message.Code === 'Awaiting Sign') {
                    setSchoolDocsInfo({
                        docs: response.data.Message.Data.results,
                        logo: bookingItem.schoolLogo,
                        name: bookingItem.schoolName,
                    });
                    setSignDocsOpen(true);
                    let changeStatus = {
                        status: 'Pending',
                        id: bookingItem.uniqueId,
                    };
                    dispatch(updateBookingStatus(changeStatus));
                    return;
                }

                dispatch(quickBookingConfirmed(response.data));
                // setSnackState({
                //     snackBarMessage: 'Booking Updated',
                //     openSnack: true,
                //     snackSeverity: 'success',
                // });
                sendNotification('success', 6000, 'Booking Updated');
            })
            .catch(err => {
                changeStatus.status = originalStatus;
                dispatch(updateBookingStatus(changeStatus));
                console.log('Alert Customer of Failure');
                // setSnackState({
                //     snackBarMessage: 'Booking Failed to Update',
                //     openSnack: true,
                //     snackSeverity: 'error',
                // });

                sendNotification('error', 0, 'Booking Failed to Update');
            });
        console.log('Response from API ' + JSON.stringify(response));
    };

    const confirmBooking = async (approve, date) => {
        if (approve === undefined) {
            approve = cached.approve;
            date = cached.date;
        } else {
            setCached({
                approve: approve,
                date: date,
            });
        }

        try {
            const originalStatus = state.booking.status;

            let changeStatus = {
                status: 'Processing',
                id: state.booking.uniqueId,
            };
            dispatch(updateBookingStatus(changeStatus));
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });

            if (state.booking.type === 'quickBook') {
                const route = '/confirmQuickBooking';

                if (availabilityStatus === 'idle') {
                    const availStatus = await dispatch(
                        fetchMyAvailability(token)
                    );
                    console.log('availStatus', availStatus);
                    if (
                        availStatus.payload.availability.Message.Success ===
                        true
                    ) {
                        //data.pk1 = 'r1r34-20210824' // state.booking.startDate = '2022-10-29T08:00:00'

                        await addQuickBookAndAvail(
                            state.booking,
                            availStatus.payload.availability.Message.Data,
                            changeStatus,
                            token,
                            date,
                            approve,
                            route,
                            originalStatus
                        );
                    }
                } else {
                    //find the availability that matches the day then add to the availability

                    await addQuickBookAndAvail(
                        state.booking,
                        availability.Data,
                        changeStatus,
                        token,
                        date,
                        approve,
                        route,
                        originalStatus
                    );
                }
            } else {
                const data = {
                    'request': { 'approve': approve.toString(), 'date': date },
                };
                const route = '/confirmBooking';

                const response = await axios
                    .put(route, data.request, {
                        baseURL: process.env.REACT_APP_API_GATEWAY,
                        url: route,
                        timeout: 30000,
                        headers: {
                            authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                    })
                    .then(response => {
                        try {
                            const availStatus = {
                                status: response.data.Message.Data.availStatus,
                                id: state.booking.availId,
                            };
                            dispatch(updateAvailStatus(availStatus));
                        } catch {
                            console.log('Availability not in memory');
                        }

                        if (response.data.Message.Code === 'Awaiting Sign') {
                            setSignDocsOpen(true);
                            setSchoolDocsInfo({
                                docs: response.data.Message.Data.results,
                                logo: state.booking.schoolLogo,
                                name: state.booking.schoolName,
                            });
                            changeStatus.status = 'Pending';
                            dispatch(updateBookingStatus(changeStatus));
                        } else {
                            changeStatus.status =
                                response.data.Message.Data.bookingStatus;

                            dispatch(updateBookingStatus(changeStatus));

                            // setSnackState({
                            //     snackBarMessage: 'Booking Updated',
                            //     openSnack: true,
                            //     snackSeverity: 'success',
                            // });

                            sendNotification(
                                'success',
                                6000,
                                'Booking Updated'
                            );
                        }
                    })
                    .catch(err => {
                        changeStatus.status = originalStatus;
                        dispatch(updateBookingStatus(changeStatus));
                        console.log('Alert Customer of Failure');
                        // setSnackState({
                        //     snackBarMessage: 'Booking Failed to Update',
                        //     openSnack: true,
                        //     snackSeverity: 'error',
                        // });
                        sendNotification(
                            'error',
                            0,
                            'Booking Failed to Update'
                        );
                    });
                console.log('Response from API ' + JSON.stringify(response));
            }
        } catch (err) {
            console.log('error', err);
        }
    };

    let action;

    if (state.bookingStatus === 2) {
        if (
            state.booking.status === 'Pending' ||
            state.booking.status === 'Processing'
        ) {
            action = (
                <TeacherApprove
                    booking={state.booking}
                    confirmBooking={confirmBooking}
                />
            );
        } else if (
            state.booking.status === 'Approved' &&
            compareDesc(parseISO(state.booking.endDate), Date.now()) === 1 &&
            typeof state.booking.teacherFeedback === 'undefined'
        ) {
            action = (
                <TeacherCompleted
                    status={state.booking.status}
                    sk1={state.booking.sk1}
                    id={state.booking.uniqueId}
                ></TeacherCompleted>
            );
        } else if (state.booking.status === 'Reserved') {
            if (
                typeof state.booking.bookedBy !== 'undefined' &&
                state.booking.bookedBy.uniqueId ===
                    profile.Data.Items[0].uniqueId
            ) {
                action = (
                    <Typography variant="h5">
                        Congratulations! You have secured the booking.
                    </Typography>
                );
            } else {
                action = (
                    <>
                        <Typography variant="h5">
                            Sorry! Another teacher has already accepted the
                            booking.
                        </Typography>
                        <Typography variant="body">
                            Log in as quickly as you can when you are notified
                            there is a quick booking available in your area.
                        </Typography>
                    </>
                );
            }
        } else {
            action = (
                <Typography variant="h5">Actions are completed</Typography>
            );
        }
    } else {
        action = <Typography variant="h5">Actions are completed</Typography>;
    }

    let content;

    if (state.bookingStatus === 2) {
        if (typeof state.booking.uniqueId !== 'undefined') {
            content = (
                <div>
                    <BookingHeader booking={state.booking} userType="Teacher" />
                    <RootGrid container xs={12}>
                        <BookingSubDetails booking={state.booking} teacher />
                    </RootGrid>
                    {/* Need to test this piece of code */}
                    {state.booking.status === 'Processed' && (
                        <RootGrid>
                            <BookingRating
                                rating={state.booking.teacherRating}
                                comments={state.booking.teacherRatingComments}
                            />
                        </RootGrid>
                    )}
                    <RootGrid container xs={12} sx={{ margin: '22px 0px' }}>
                        <SimpleMap
                            center={{
                                lat: parseFloat(state.booking.schoolLat),
                                lng: parseFloat(state.booking.schoolLng),
                            }}
                            address={state.booking.schoolLocation}
                            zoom={14}
                        />
                    </RootGrid>
                </div>
            );
        } else {
            content = <NoBookingFound />;
        }
    } else if (state.bookingStatus === 1) {
        <Loading />;
    } else {
        content = <NoBookingFound />;
    }

    return (
        <div>
            <Grid container directon="row" justifyContent="center">
                <Title title="Booking Summary" />
                {state.bookingStatus === 2 &&
                    typeof state.booking.uploadedDocuments !== 'undefined' && (
                        <Grid
                            item
                            xs={12}
                            md={8}
                            directon="row"
                            justifyContent="flex-start"
                            alignContent="stretch"
                        >
                            {state.booking.uploadedDocuments.map(document => (
                                <SchoolInfoProvided
                                    title="Pre-booking Details"
                                    subtitle="Information for the upcoming shift"
                                    bookingDocExist={
                                        typeof document.document !== 'undefined'
                                    }
                                    text={document.text}
                                    endDate={state.booking.endDate}
                                    sk1={state.booking.sk1}
                                    schoolUploadDocument={document.document}
                                    userType="Teacher"
                                    uploader={document.userName}
                                />
                            ))}
                        </Grid>
                    )}
                {state.bookingStatus === 2 &&
                    typeof state.booking.teacherFeedback !== 'undefined' && (
                        <Grid
                            item
                            xs={12}
                            md={8}
                            directon="row"
                            justifyContent="flex-start"
                            alignContent="stretch"
                        >
                            <TeacherFeedback
                                report={state.booking.teacherFeedback}
                            />
                        </Grid>
                    )}
                <Grid
                    item
                    xs={12}
                    md={8}
                    directon="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Grid item xs={12}>
                        {state.booking !== undefined && (
                            <div>
                                {(state.booking.status === 'Pending' ||
                                    state.booking.status === 'Reserved' ||
                                    state.booking.status === 'Processing' ||
                                    (state.booking.status === 'Approved' &&
                                        compareDesc(
                                            parseISO(state.booking.endDate),
                                            Date.now()
                                        ) === 1)) &&
                                    typeof state.booking.teacherFeedback ===
                                        'undefined' && (
                                        <Card
                                            sx={{
                                                margin: '20px',
                                                padding: '20px',
                                            }}
                                        >
                                            {action}
                                        </Card>
                                    )}
                            </div>
                        )}

                        <TeacherCard>{content}</TeacherCard>
                    </Grid>
                </Grid>
            </Grid>
            <RootGrid container align="center">
                <Grid item xs={12}>
                    <Box>
                        <BookingButton
                            onClick={goBack}
                            variant="outlined"
                            color="secondary"
                            size="large"
                        >
                            Back
                        </BookingButton>
                    </Box>
                </Grid>
            </RootGrid>
            {signDocsOpen && (
                <SignSchoolDocs
                    setOpen={setSignDocsOpen}
                    schoolDocsInfo={schoolDocsInfo}
                    setSnack={setSnackState}
                    confirmBooking={confirmBooking}
                />
            )}
            <SimpleSnackbar
                open={snackState.openSnack}
                severity={snackState.snackSeverity}
                message={snackState.snackBarMessage}
            />
        </div>
    );
};

export default withAuthenticationRequired(ViewTeacherBooking, {
    onRedirecting: () => <Loading />,
});
